import { render, staticRenderFns } from "./ThumbnailPolaroid.vue?vue&type=template&id=5e913c50&scoped=true&"
import script from "./ThumbnailPolaroid.vue?vue&type=script&lang=js&"
export * from "./ThumbnailPolaroid.vue?vue&type=script&lang=js&"
import style0 from "./ThumbnailPolaroid.vue?vue&type=style&index=0&id=5e913c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e913c50",
  null
  
)

export default component.exports